export default __webpack_public_path__ + "static/interieur.cover-df9e91844541ce34b86447f25ebc406a.jpg";